import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Breadcrumbs from "../BreadCrum/BreadCrum";
import PageHeadingSection from "../pageheading/PageHeadingSection";
import CommonTable from "../table/ComonTable";
import { emergencyApi, readSession, apiMessage } from "./emergencyApi";

const ActiveEmergencyList = () => {
    const { user } = useSelector((state) => state.auth);
    const { siteId, userId } = readSession(user);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const response = await emergencyApi.getActive(siteId, userId);
            const list = response.data?.emergencies || [];
            setRows(list.map((item) => ({ ...item, id: item.id })));
        } catch (error) {
            toast.error(apiMessage(error, "Failed to load active emergencies"));
            setRows([]);
        } finally {
            setLoading(false);
        }
    }, [siteId, userId]);

    useEffect(() => { load(); }, [load]);

    const resolve = async (row) => {
        try {
            const response = await emergencyApi.updateStatus(row.id, { userId, status: "RESOLVED", resolved_notes: "Resolved from Emergency Services" });
            if (response.data?.isSuccess === false) {
                toast.error(response.data?.message || "Failed to resolve");
                return;
            }
            toast.success("Emergency resolved");
            load();
        } catch (error) {
            toast.error(apiMessage(error, "Failed to resolve"));
        }
    };

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto pt-4 scrollbar-hide">
            <Breadcrumbs items={["Emergency Services", "Active"]} />
            <PageHeadingSection mainHeading="Active emergencies" subHeading="Resolve an open emergency when the incident is closed." />
            <div className="mt-4">
                <CommonTable
                    loading={loading}
                    headers={[
                        { label: "TYPE", key: "type" },
                        { label: "LOCATION", key: "location" },
                        { label: "STATUS", key: "status" },
                        { label: "REPORTED", key: "reported" },
                        { label: "ACTIONS", key: "actions" }
                    ]}
                    data={rows}
                    renderCell={(key, row) => {
                        if (key === "type") return row.emergency_type_name || "—";
                        if (key === "location") return row.location || "—";
                        if (key === "status") return row.status || "—";
                        return row.reported_at ? new Date(row.reported_at).toLocaleString() : "—";
                    }}
                    customAction={{ label: () => "Resolve", icon: faCheck, onClick: resolve }}
                />
            </div>
        </div>
    );
};

export default ActiveEmergencyList;
